import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import MilestoneModel from '../../../models/MilestoneModel';
import ProjectItemRevisionModel from '../../../models/ProjectItemRevisionModel';
import DataService from "../../../services/data.service";
import { ItemRevisionIdProps } from '../../../types/IdProps';

interface MilestoneTabProps extends ItemRevisionIdProps {
    milestones: MilestoneModel[]
}

const ItemRevision_tab_Milestones: React.FC<MilestoneTabProps> = ({ itemRevisionId, milestones }) => {
    const [data, setData] = useState<any[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [itemRevisionId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/ProjectItemRevisions/ByItemRevision/' + itemRevisionId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'projectId', visible: false },
        { title: 'Project', dataProp: 'project', dataType: 'project', sort: 'asc', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Project type', dataProp: 'project.projectType', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Started on', dataProp: 'project.startedOn', dataType: 'date' },
    ];
    milestones.forEach(x => {
        colInfos.push({
            title: x.milestoneName,
            dataProp: x.milestoneName,
            dataType: 'date',
            getCellData: getCellData,
            getCellBackgroundColor: getCellColor
        });
    });
    colInfos.push({ title: 'Deadline', dataProp: 'project.deadline', dataType: 'date' });
    colInfos.push({ title: 'Finished on', dataProp: 'project.finishedOn', dataType: 'date' });

    function getCellData(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo) {
        let value: string | undefined;
        if (projectItemRevision.milestones)
            projectItemRevision.milestones.forEach(x => {
                if (x.milestoneName == colInfo.dataProp)
                    value = x.milestoneDate;
            });
        return value;
    }

    function getCellColor(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo) {
        let value: string = '';
        if (projectItemRevision.milestones)
            projectItemRevision.milestones.forEach(x => {
                if (x.milestoneName == colInfo.dataProp)
                    value = x.color;
            });
        return value;
    }

    console.log('Milestones:', milestones)

    return (
        <>
            <DataTable
                name='dtItemMilestones'
                colInfos={colInfos}
                tableData={data}
            />
        </>
    );
}
export default ItemRevision_tab_Milestones;

